import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-open-line text-xl text-accent-400"></i>
                </div>
                <span className="font-heading text-lg font-bold">秘密教学漫画</span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed">
                最全面的秘密教学漫画内容导览平台，提供最新章节解析、角色介绍、深度评测与精彩合集。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                内容导航
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/latest-chapters" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    最新章节
                  </Link>
                </li>
                <li>
                  <Link to="/category/plot-analysis" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    剧情解析
                  </Link>
                </li>
                <li>
                  <Link to="/category/character-intro" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    角色介绍
                  </Link>
                </li>
                <li>
                  <Link to="/category/reviews" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    深度评测
                  </Link>
                </li>
                <li>
                  <Link to="/category/collections" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    合集推荐
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                关于本站
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                    使用条款
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer" rel="nofollow">
                    免责声明
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">
                关注我们
              </h4>
              <p className="text-sm text-secondary-300 mb-4 leading-relaxed">
                获取秘密教学漫画最新动态与深度内容更新通知。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-300 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="B站" rel="nofollow">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} 秘密教学漫画内容平台。本站为粉丝内容聚合平台，所有原创文章版权所有。
            </p>
            <p className="text-xs text-secondary-400">
              本站不提供漫画原作在线阅读，仅供内容导览与分析评测。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}